import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import LegCardShell from './LegCardShell.vue'
import CommandLocationSearch from '@/components/core/CommandLocationSearch.vue'
import type { LocationAutocompleteResult } from '@/types/trip'


export default /*#__PURE__*/_defineComponent({
  __name: 'AnchorLocationCard',
  props: {
    side: null,
    checked: { type: Boolean },
    waypointName: null,
    location: null,
    placeholder: null,
    disabled: { type: Boolean },
    disabledHint: null,
    invalid: { type: Boolean },
    errorMessage: null
  },
  emits: ["change", "update:location"],
  setup(__props: any) {

const props = __props as {
  side: 'arrival' | 'departure'
  checked: boolean
  waypointName: string
  location?: LocationAutocompleteResult
  placeholder: string
  disabled?: boolean
  disabledHint?: string
  invalid?: boolean
  errorMessage?: string
};





const storeId = computed(() =>
  props.side === 'arrival'
    ? 'leg-picker-arrival-origin'
    : 'leg-picker-departure-destination',
)

return { __sfc: true,props, storeId, LegCardShell, CommandLocationSearch }
}

})